import React from 'react';
import { useHistory } from 'react-router-dom';
import Box from '@amzn/awsui-components-console/box';
import Button from '@amzn/awsui-components-console/button';
import SpaceBetween from '@amzn/awsui-components-console/space-between';

const NotFound: React.FC = () => {
	const history = useHistory();

	return (
		<Box textAlign="center" padding={{ vertical: 'xxxl' }}>
			<SpaceBetween size="l">
				<Box variant="h1" fontSize="heading-xl">
					Page Not Found
				</Box>
				<Box variant="p" color="text-body-secondary">
					The page you are looking for does not exist or has been moved.
				</Box>
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<SpaceBetween direction="horizontal" size="xs">
						<Button onClick={() => history.goBack()}>Go Back</Button>
						<Button variant="primary" onClick={() => history.push('/home')}>
							Go to Home
						</Button>
					</SpaceBetween>
				</div>
			</SpaceBetween>
		</Box>
	);
};

export default NotFound;
